import { render, staticRenderFns } from "./configuracionHdxCompletas.vue?vue&type=template&id=a038207e"
import script from "./configuracionHdxCompletas.vue?vue&type=script&lang=js"
export * from "./configuracionHdxCompletas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports